import { render, staticRenderFns } from "./supplyConfig.vue?vue&type=template&id=0c092cc6&scoped=true&"
import script from "./supplyConfig.vue?vue&type=script&lang=js&"
export * from "./supplyConfig.vue?vue&type=script&lang=js&"
import style0 from "./supplyConfig.vue?vue&type=style&index=0&id=0c092cc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c092cc6",
  null
  
)

export default component.exports